import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface UpdateClassCountTuitionBillingParams {
  chartId: string;
  params: {
    name: string;
    ranges: Array<{
      minClasses: number;
      maxClasses: number;
      flatRate: number;
    }>;
  };
}

export const updateClassCountTuitionBilling = async ({
  chartId,
  params,
}: UpdateClassCountTuitionBillingParams) => {
  const response = await baseAPI.put(
    `class-count-tuition-billing/${chartId}`,
    params,
  );
  return response.data;
};

export const useUpdateClassCountTuitionBilling = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateClassCountTuitionBilling,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.CLASS_COUNT_TUITION_BILLING],
      });
    },
  });
};
